import { mapActions } from 'vuex';

export default {
	name: 'DeleteSpareTypeDialog',
	data() {
		return {
			loadingSave: false,
			listError : [],
		};
	},
	props: {
		value: Boolean,
		item: Object,
	},
	computed: {
		dialog: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},
	methods: {
		...mapActions('spareType', ['deleteSpareType']),
		close() {
			this.dialog = false;
			this.listError = [];
		},
		async deleteItemConfirm() {
			if (this.item) {
				this.loadingSave = true;
				const { ok,error } = await this.deleteSpareType(this.item.id);
				if (ok) {
					this.close();
					this.$emit('getSparesSubtype');
				} else {
					this.listError = Array.isArray(error?.data?.message)
					? error?.data?.message
					: [error?.data?.message] || [];
					this.loadingSave = false;
				}
				this.loadingSave = false;
			}
		},
	},
};
